import { useState, useEffect, useCallback } from "react";
import { Button, TextField, Tooltip, IconButton } from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import designForgstr6aRep from "../GSTR2B_Repository/Gstr2bRepository.module.css";
import axios from "../../../../axios-order";
import moment from "moment";
import DatePicker from "../GSTR2B_Repository/DatePicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const dateFormat = (value) => {
  if (!value) return "";

  const m = moment(
    value,
    ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"],
    true,
  );

  return m.isValid() ? m.format("DD/MM/YYYY") : "";
};

export default function Gstr6aRepository() {
  const [fileName, setFileName] = useState("");
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [toMonthError, setToMonthError] = useState("");
  const [showSuccessOnly, setShowSuccessOnly] = useState(false);
  const history = useHistory();

  //...............For Error Message..........................
  const [, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [, setErrorMessageVisibilityStyle] = useState("hidden");
  const [, setErrorMessageDisplayStyle] = useState("none");

  //...........Record From Get Api.................
  const [recordForTable, setRecordForTable] = useState([]);
  const [recordForTableSearch, setRecordForTableSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);

  // ..............this is Auto GSTR Download
  // const [retPeriod, setRetPeriod] = useState("");
  const [fromRetPeriod, setFromRetPeriod] = useState("");
  const [toRetPeriod, setToRetPeriod] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  //   Gstr Status code begin
  const [responseData] = useState("");
  const [taskId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  //Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    const autoDownload = async () => {
      // Call the additional API only when taskId is available
      if (taskId) {
        try {
          const additionalApiUrl = `/autodownloadapi/${taskId}`;
          await axios.get(additionalApiUrl);
        } catch (error) {
          console.error("Error calling additional API:", error);
        }
      }
    };
    autoDownload();
  }, [taskId]);

  // Function to open Snackbar
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  // Function to close Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarSeverity("success");
    setResponseMessage("");
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };

  const handleToastifyNotification = (response, uploadStatus, fileExt) => {
    handleSnackbarOpen(
      response,
      uploadStatus === "Success"
        ? "success"
        : uploadStatus === "Failed"
          ? "error"
          : "info",
    );
  };

  // const inputHandlerFromPicker = (v) => {
  //   const formattedDate = v ? moment(v).format("MMYYYY") : "";
  //   setRetPeriod(formattedDate);
  //   setToMonthError("");
  // };
  const inputHandlerFromPicker = (v) => {
    const formattedDate = v ? moment(v).format("MMYYYY") : "";
    setFromRetPeriod(formattedDate);
    setToRetPeriod("");
    setToMonthError("");
  };

  // ADD new To picker handler
  const inputHandlerToPicker = (v) => {
    const formattedDate = v ? moment(v).format("MMYYYY") : "";
    setToRetPeriod(formattedDate);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
    }, 7000);
    return () => clearTimeout(timer);
  }, [responseMessage]);

  /// This changes for the handlegstr6a
  const handlegstr6aDownload = async () => {
    setIsSubmitting(true);

    const url = `/gstr6a_autodownload`;
    const entity_id = localStorage.getItem("business_entity_id");
    const gstin = localStorage.getItem("gst");

    const response = await axios.post(url, {
      entity_id,
      gstin,
      fromPeriod: fromRetPeriod,
      toPeriod: toRetPeriod,
    });
    try {
      const responseData = response.data;

      if (responseData.status === false && responseData.message) {
        handleSnackbarOpen(responseData.message, "error");
      } else if (responseData.status === "success" && responseData.message) {
        handleSnackbarOpen(responseData.message, "success");
      } else if (responseData.message_type && responseData.message) {
        handleSnackbarOpen(responseData.message, responseData.message_type);
      } else {
        handleSnackbarOpen("An unexpected response was received.", "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("Unexpected Error.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  //.......Handle Search....................
  const handleSearch = (e) => {
    let Search = e.target.value.trim();
    const searchName = recordForTableSearch.filter((v) => {
      return (
        String(v.gstr_upload_file_type)
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0 ||
        String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
          Search,
        ) >= 0 ||
        String(
          moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
        ).indexOf(Search) >= 0
      );
    });
    setRecordForTable(searchName);
  };

  //........For Succesfull Message..................
  const functionForSuccesfullMessageAndErroeMessage = (
    color,
    visible,
    display,
    message,
  ) => {
    setColorForErrorMessage(color);
    setErrorMessageVisibilityStyle(visible);
    setErrorMessageDisplayStyle(display);
    setErrorMessage(message);
  };

  //.............File Upload Data Saving in useState..............
  const handleFileUpload = (e) => {
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    if (e.target.files.length) {
      const file_data = e.target.files[0];
      let fileName = file_data.name;
      setFileName(fileName);
      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      reader.onload = function () {
        let file_value = reader.result;
        setFileDataToUpload(file_value);
      };
      e.target.value = null;
    }
  };

  //......Submit Event For File Upload in axios.......
  const handleSubmitEvent = async () => {
    if (fileName === "") {
      functionForSuccesfullMessageAndErroeMessage(
        "red",
        "visible",
        "block",
        "Please Upload The File!",
      );
    } else {
      try {
        const response = await axios.post(`/gstr6a_upload`, {
          file: fileDataToUpload,
          gstin: localStorage.getItem("gst"),
        });

        if (response.data.status === true) {
          getApiForGst6aRepository();
          handleSnackbarOpen(response.data.message);
          resetFileUpload();
        } else {
          handleSnackbarOpen(response.data.Message, "error");
          resetFileUpload();
        }
      } catch (error) {
        functionForSuccesfullMessageAndErroeMessage(
          "red",
          "visible",
          "block",
          error.response.data.Message,
        );
        handleSnackbarOpen(error.response.data.Message, "error");
        resetFileUpload();
      }
    }
  };

  const resetFileUpload = () => {
    setFileDataToUpload(null);
    setFileName("");
  };

  //.......................Get Api For Gst................
  const getApiForGst6aRepository = useCallback(async () => {
    try {
      setLoaderForTable(true);
      const response = await axios.post(`/gstr6a_upload_get`, {
        org_gstin: localStorage.getItem("gst"),
      });
      if (!response.data.status) {
        handleSnackbarOpen(response.data.message, "info");
        return;
      }
      setRecordForTable(response.data.record);
      setRecordForTableSearch(response.data.record);
    } catch (error) {
      handleSnackbarOpen(error, "error");
    } finally {
      setLoaderForTable(false);
    }
  }, []);

  const newReconModalClose = () => {
    setFileName("");
    setFromRetPeriod("");
    setToRetPeriod("");
    setFileDataToUpload("");
    setErrorMessage("");
  };

  useEffect(() => {
    getApiForGst6aRepository();
  }, [getApiForGst6aRepository]);

  return (
    <>
      <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBackNavigation}
            sx={{
              borderRadius: "50%",
              padding: "6px",
              color: "#263238",
              fontSize: "20px",
              backgroundColor: "#ffffff",
              height: "36px",
              width: "36px",
              "&:hover": {
                backgroundColor: "#455a64",
                color: "#ffffff",
              },
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
              transition: "background-color 0.3s ease",
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>
      </div>
      <BoxWrapper
        boxTitle={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              paddingRight: "20px",
              position: "relative",
            }}
          >
            <span style={{ fontWeight: 600, color: "#000" }}>
              GSTR-6A Repository
            </span>
            <span
              style={{
                fontWeight: 600,
                position: "absolute",
                left: "45%",
                transform: "translateX(-50%)",
              }}
            >
              GSTR-6A Auto Download
            </span>
          </div>
        }
      >
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            if (fileName && fileDataToUpload) {
              handleSubmitEvent(e);
            } else if (fromRetPeriod && toRetPeriod) {
              handlegstr6aDownload();
            }
          }}
          onError={(errors) => console.error(errors)}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "40px",
                overflow: "auto hidden",
              }}
            >
              {/* Upload Button */}
              <div style={{ minWidth: "100px" }}>
                <label
                  className="button-primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: fromRetPeriod ? "not-allowed" : "pointer",
                    padding: "8px",
                    display: "block",
                    opacity: fromRetPeriod ? 0.5 : 1,
                    pointerEvents: fromRetPeriod ? "none" : "auto",
                  }}
                >
                  Upload
                  <input
                    type="file"
                    accept=".xlsx,.json,.zip"
                    onChange={handleFileUpload}
                    hidden
                    disabled={!!fromRetPeriod}
                  />
                </label>
              </div>

              {/* File name field */}
              <div style={{ flex: "0 0 350px" }}>
                <TextField
                  placeholder="Choose file"
                  value={fileName}
                  variant="standard"
                  fullWidth
                  disabled={!!fromRetPeriod}
                  style={{ opacity: fromRetPeriod ? 0.5 : 1 }}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </div>

              {/* NEW - two pickers */}
              <div style={{ width: "200px", minWidth: "200px", opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: "black", display: "block", marginBottom: "4px", fontSize: "14px" }}>
                  Please Select From Month<span style={{ color: "red" }}>*</span>:
                </label>
                <div style={{ width: "200px" }}>
                  <DatePicker
                    views={["year", "month"]}
                    placeholder="From Month and Year"
                    format="MM/yyyy"
                    value={fromRetPeriod}
                    onChange={inputHandlerFromPicker}
                    disabled={!!fileName}
                  />
                </div>
              </div>

              <div style={{ width: "200px", minWidth: "200px", opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: "black", display: "block", marginBottom: "4px", fontSize: "14px" }}>
                  Please Select To Month<span style={{ color: "red" }}>*</span>:
                </label>
                <div style={{ width: "200px" }}>
                  <DatePicker
                    views={["year", "month"]}
                    placeholder="Select To Month and Year"
                    format="MM/yyyy"
                    value={toRetPeriod}
                    onChange={inputHandlerToPicker}
                    disabled={!fromRetPeriod || !!fileName}
                  />
                </div>
              </div>

              {/* Button Group */}
              <div style={{ display: "flex", gap: "5px", marginLeft: "-25px" }}>
                <div style={{ minWidth: "100px" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    className={designForgstr6aRep.submitButton}
                    disabled={isSubmitting || !!toMonthError}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </div>

                <div style={{ minWidth: "100px" }}>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    onClick={newReconModalClose}
                    style={{ width: "100%", padding: "8px" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
        )}
      </BoxWrapper>

      {/*..................Table.......................*/}
      <BoxWrapper
        boxTitle="History"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst6aRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>gstr6a UPLOAD FILE TYPE</th>
                <th>TAX PERIOD</th>
                <th>FINANCIAL YEAR</th>
                <th>GENERATION DATE</th>
                <th>UPLOAD DATE</th>
                <th>STATUS</th>
                <th>
                  <label>
                    <input
                      type="checkbox"
                      checked={showSuccessOnly}
                      onChange={() => setShowSuccessOnly(!showSuccessOnly)}
                    />
                    Show Success Only
                  </label>
                </th>
                {/* <th>ACTION</th> */}
              </tr>
            </thead>
            <tbody>
              {recordForTable.map((v, index) => {
                if (showSuccessOnly && v.upload_status !== "Success") {
                  return null;
                }

                return (
                  <tr key={index}>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.gstr_upload_file_ext}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.tax_period !== "None"
                        ? moment(v.tax_period, "MMYYYY").format("MMMM-YYYY")
                        : ""}
                    </td>
                    <td>
                      {v.financial_year !== "None" ? v.financial_year : ""}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.generation_date ? dateFormat(v.generation_date) : ""}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.upload_date !== "None"
                        ? dateFormat(v.upload_date)
                        : ""}
                    </td>
                    <td>{v.upload_status}</td>
                    <td>
                      {v.upload_status ? (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleToastifyNotification(
                              v.upload_fail_reason,
                              v.upload_status,
                              v.gstr_upload_file_ext,
                            )
                          }
                        >
                          <VisibilityOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{
                              color:
                                v.upload_status === "Success"
                                  ? "#2938c2"
                                  : "#b4bfbf",
                            }}
                          />
                        </div>
                      ) : (
                        <VisibilityOutlinedIcon
                          className="action-icon-button showIcon"
                          onClick={() => alert("Data Uploaded")}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
              {loaderForTable ? (
                <tr>
                  <td
                    colSpan={7}
                    style={{
                      color: "black",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Loading…Please wait
                  </td>
                </tr>
              ) : recordForTable.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {responseData && (
        <div>
          <p style={{ fontSize: "20px", color: "green" }}>
            DOWNLOADED GSTR DATA
          </p>
          <p>{responseData}</p>
        </div>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: "25%" }}
      >
        <MuiAlert
          elevation={2}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
